import { addDays, eachDayOfInterval, format, parseISO } from "date-fns";
import React, { useCallback } from "react";
import { Spinner } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { DatePicker } from "../../../../Common/Components/DatePicker";
import OrderSummaryItems from "../../../../Common/Components/OrderSummaryItems";
import TotalPriceCard from "../../../../Common/Components/SummaryTotalPriceCard";
import { TitleHeader } from "../../../../Common/Components/TitleHeader";
import useCartTotal from "../../../../Common/Hooks/useCartTotal";
import { isDateBetween } from "../../../../Services/MainService";
import { fetchWeekDaysOff } from "../../../../Services/OrderService";
import { AddressPicker } from "../../../Components/AddressPicker";
import {
  fetchCoupon,
  fetchServices,
  fetchTimeSlot,
} from "../../../Services/OrderService";
import OrderNotesPicker from "../../../../Common/Components/OrderNotesPicker";

export const OrderSummary = () => {
  const [amount, count] = useCartTotal();
  const [addressModal, setAddressModal] = React.useState(null);
  const dts = useSelector((store) => store.OrderTypes);
  const orderTypeId = useSelector((x) => x.OrderTypeId);
  const cart = useSelector((x) => x.Cart);
  const coupon = useSelector((x) => x.Coupon);
  const dates = useSelector((x) => x.Dates);
  const note = useSelector((x) => x.Note);
  const selfPick = useSelector((x) => x.SelfPick);
  const customerId = useSelector((x) => x.CustomerId);
  const addresses = useSelector((x) => x.Addresses);
  const bookingType = useSelector((x) => x.BookingType);
  const apiNotes = useSelector((x) => x.Customer?.customer_note) || [];
  const store = useSelector((x) => x.Store);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [loading, setLoading] = React.useState(false);
  const [deliveryTypes, setDeliveryTypes] = React.useState(null);
  const [pickupRange, setPickupRange] = React.useState([]);
  const [deliveryRange, setDeliveryRange] = React.useState([]);
  const [showDatePicker, setShowDatePicker] = React.useState(null);
  const [cLoading, setCLoading] = React.useState(false);
  const [code, setCode] = React.useState(coupon?.coupon?.code ?? "");
  const [address, setAddress] = React.useState({});
  const [date, setDate] = React.useState({
    pickup: { date: null, slot: null },
    delivery: { date: null, slot: null },
    eDelivery: { date: null, slot: null },
  });
  const [items, setItems] = React.useState([]);
  const [services, setServices] = React.useState([]);
  const [loaded, setLoaded] = React.useState(false);
  const [weekDaysOff, setWeekDaysOff] = React.useState(null);
  const [datesLoading, setDatesLoading] = React.useState(false);
  // const hasExpress = useHasExpress(items);
  const [open, setOpen] = React.useState({});
  const setNote = (e) => {
    dispatch({ type: "setNote", payload: e });
  };

  const FilterRange = useCallback(
    (range) => {
      return range.filter((date) => {
        const day = format(date, "EEEE").toLowerCase();
        const dateStringFormatted = format(date, "yyyy-MM-dd");

        return (
          !weekDaysOff?.weekdaysOff.includes(day) &&
          !weekDaysOff?.offDays.includes(dateStringFormatted)
        );
      });
    },
    [weekDaysOff]
  );

  React.useEffect(() => {
    setLoading(true);
    if (cart && cart.length > 0) {
      const r = dts.reduce((result, item) => {
        result[item.id] = item;
        return result;
      }, {});
      setDeliveryTypes(r);
      fetchServices(50, 1, orderTypeId).then(
        (res) => {
          setServices(res);
        },
        (err) => console.warn(err, "err while fetching services...")
      );
    } else navigate("/", { replace: true });
  }, [cart, navigate, dts, orderTypeId]);
  React.useEffect(() => {
    fetchWeekDaysOff(orderTypeId).then(
      (res) => setWeekDaysOff(res),
      () => toast.error("Something went wrong!")
    );
  }, [orderTypeId]);
  React.useEffect(() => {
    if (weekDaysOff && items.length > 0) {
      if (deliveryTypes) {
        const sd = addDays(
          new Date(),
          deliveryTypes[orderTypeId]?.["pickup_duration"]
        );
        const ed = addDays(
          sd,
          (deliveryTypes[orderTypeId]?.["noOf_calender_dates"] || 15) - 1
        );
        const dif = FilterRange(eachDayOfInterval({ start: sd, end: ed }));
        if (dates?.pickup?.date && dates?.pickup?.slot) {
          setDate((p) => ({
            ...p,
            pickup: {
              date: dates?.pickup?.date,
              slot: dates?.pickup?.slot,
            },
          }));
        }
        setPickupRange(dif);
      }
    }
  }, [
    dates?.pickup,
    weekDaysOff,
    items,
    deliveryTypes,
    FilterRange,
    orderTypeId,
  ]);

  const timeToMinutes = (hhmmss) => {
  if (!hhmmss || typeof hhmmss !== "string") return null; // safe
  const [h, m] = hhmmss.split(":").map(Number);
  if (Number.isNaN(h) || Number.isNaN(m)) return null;
  return h * 60 + m;
};

const isCutoffPassed = (cutoff_time) => {
  const cutoffMin = timeToMinutes(cutoff_time);
  if (cutoffMin === null) return false; // no cutoff => behave normal
  const now = new Date();
  const nowMin = now.getHours() * 60 + now.getMinutes();
  return nowMin >= cutoffMin;
};

// const isPickupFirstSlot = (pickupSlot) => {
//   // based on your known 2-slot system (1–5pm then 5–9pm)
//   // safest is to use start_time if present
//   const st = pickupSlot?.start_time;
//   if (!st || typeof st !== "string") return true; // default safe
//   // quick heuristic: "1:00 pm" => first, "5:00 pm" => second
//   return st.toLowerCase().includes("1:") || st.toLowerCase().includes("01:");
// };

  React.useEffect(() => {
    if (weekDaysOff && deliveryTypes) {
      if (date.pickup.date) {
        let skip = deliveryTypes[orderTypeId]?.duration;
        if (orderTypeId != 1 && orderTypeId != 2) {
          const serv = services.find((x) => x.id == items[0]?.services_id);
          console.log(serv);
          if (serv)
            skip =
              bookingType == 1 ? serv.regular_duration : serv.express_duration;
        }

        const sd = addDays(date.pickup.date, skip);
        const ed = addDays(
          sd,
          (deliveryTypes[orderTypeId]?.["noOf_calender_dates"] || 15) - 1
        );
        const dif = FilterRange(eachDayOfInterval({ start: sd, end: ed }));
        setDeliveryRange(dif);
        const d_d = dates?.delivery;
        if (d_d?.date) {
          const ld =
            typeof d_d?.date == "string" ? parseISO(d_d.date) : d_d.date;
          if (!isDateBetween(ld, sd, ed)) {
            setDate((p) => ({
              ...p,
              // delivery: null,
              delivery: { date: null, slot: null},
            }));
          } else if (d_d.slot) {
            setDatesLoading(true);
            fetchTimeSlot(
              format(ld, "yyyy-MM-dd"),
              2,
              bookingType,
              date.pickup.slot?.id,
              format(date.pickup.date, "yyyy-MM-dd")
            ).then(
              (res) => {
                const sl = res.findIndex((x) => x.id === d_d.slot.id);
                if (~sl) {
                  setDate((p) => ({
                    ...p,
                    delivery: {
                      date: d_d.date,
                      slot: d_d.slot,
                    },
                  }));
                } else {
                  setDate((p) => ({
                    ...p,
                    // delivery: null,
              delivery: { date: null, slot: null},
                  }));
                  toast.warn(
                    "Delivery Time slot you selected last time is not available now please select another slot!"
                  );
                }
                setDatesLoading(false);
              },
              (er) => {
                // console.warn(er, "error on slot");
                toast.error("Something went wrong while fetching Time Slots.");
              }
            );
          }
        } else {
          if (!d_d || !d_d?.slot) {
            const pr = async () => {
              setDatesLoading(true);
              let skippedOneDay = false;
              for (let i = 0; i < dif.length; i++) {
                const d = dif[i];
                try {
                  const res = await fetchTimeSlot(
                    format(d, "yyyy-MM-dd"),
                    2,
                    bookingType,
                    date.pickup.slot?.id,
                    format(date.pickup.date, "yyyy-MM-dd")
                  );
                  // if (res.length > 0) {
                  //   setDate((p) => {
                  //     const n = { ...p, delivery: { date: d, slot: res[0] } };
                  //     dispatch({ type: "setDates", payload: n });
                  //     return n;
                  //   });
                  //   break;
                  // }

                  // if (res.length > 0) {
                  //   const cutoffPassed = isCutoffPassed(date.pickup.slot?.cutoff_time);

                  //   // default behavior (existing)
                  //   let slotIndexToPick = 0;

                  //   if (cutoffPassed) {
                  //     const pickupIsFirst = isPickupFirstSlot(date.pickup.slot);  

                  //     if (pickupIsFirst) {
                  //       // pickup was 1st slot => delivery should be 2nd slot
                  //       slotIndexToPick = 1;

                  //       // if 2nd slot doesn't exist, go next day (continue loop)
                  //       if (!res[1]) continue;
                  //     } else {
                  //       // pickup was 2nd slot => move delivery to next day 1st slot
                  //       continue; // skip this day, loop will try next date and pick res[0]
                  //     }
                  //   }

                  //   setDate((p) => {
                  //     const n = { ...p, delivery: { date: d, slot: res[slotIndexToPick] } };
                  //     dispatch({ type: "setDates", payload: n });
                  //     return n;
                  //   });
                  //   break;
                  // }

                  if (!res || res.length === 0) continue;

                  const cutoffPassed = isCutoffPassed(date.pickup.slot?.cutoff_time);
                  let pickIndex = 0; // default behavior (existing)

                  if (cutoffPassed && date.pickup.slot?.id) {
                    const pickupIndex = res.findIndex(
                      (s) => s.id === date.pickup.slot.id
                    );

                    if (pickupIndex >= 0 && res[pickupIndex + 1]) {
                      // move to next slot
                      pickIndex = pickupIndex + 1;
                    } else if (pickupIndex >= 0 && !res[pickupIndex + 1]) {
                      // no next slot → move to next day
                      if (!skippedOneDay) { skippedOneDay = format(d, "yyyy-MM-dd"); continue; }
                      pickIndex = 0;
                    }
                  }
                  if (!res[pickIndex]) continue; 
                  setDate((p) => {
                    const n = {
                      ...p,
                      delivery: { date: d, slot: res[pickIndex] },
                    };
                    dispatch({ type: "setDates", payload: n });
                    return n;
                  });

                  break; // stop after first valid delivery selection
                } catch (er) {
                  console.warn(er, "error on slot");
                  toast.error(
                    "Something went wrong while fetching Time Slots."
                  );
                }
              }
              setDatesLoading(false);
            };
            pr();
          }
        }
      }
    }
  }, [
    date.pickup,
    dates?.delivery,
    weekDaysOff,
    items,
    deliveryTypes,
    orderTypeId,
    bookingType,
    services,
    FilterRange,
    dispatch,
  ]);

  React.useEffect(() => {
    const ad = store?.laundry_store?.store_address?.[0];
    console.log(ad);

    if (selfPick === "false" || selfPick === false) {
      if (ad) {
        console.log(ad);
        const adddress = {
          pickup_coordinates: {
            longitude: ad.longitude,
            latitude: ad.latitude,
          },
          destination_coordinates: {
            longitude: ad.longitude,
            latitude: ad.latitude,
          },
          pickup_address: {
            floor: null,
            road: null,
            house: null,
            address: ad.address,
            contact_person_name: null,
            contact_person_number: null,
            addressLine1: ad.address1,
            addressLine2: ad.address2,
            area: ad.area?.name,
            area_phase: ad.phase?.name,
          },
          destination_address: {
            floor: null,
            road: null,
            house: null,
            address: ad.address,
            contact_person_name: null,
            contact_person_number: null,
            addressLine1: ad.address1,
            addressLine2: ad.address2,
            area: ad.area?.name,
            area_phase: ad.phase?.name,
          },
          isStore: true,
        };
        setAddress(adddress);
        dispatch({ type: "setAddresses", payload: adddress });
      }
    } else if (
      (selfPick === "true" || selfPick === true) &&
      addresses?.isStore
    ) {
      setAddress((v) => {
        const payload = { ...v };
        if (payload.destination_coordinates)
          delete payload.destination_coordinates;
        if (payload.destination_address) delete payload.destination_address;
        dispatch({ type: "setAddresses", payload });
        return payload;
      });
    }
  }, [store, selfPick]);

  React.useEffect(() => {
    if (!loaded) {
      if (addresses) {
        setAddress(addresses);
      }
      setLoaded(true);
    }
  }, [addresses, loaded]);

  const HandleDateChange = (e) => {
    if (showDatePicker === "pickup") {
      setDate((p) => {
        const n = { ...p, pickup: { date: e.date, slot: e.slot },
       delivery: { date: null, slot: null }, };
        dispatch({ type: "setDates", payload: n });
        return n;
      });
    } else if (showDatePicker === "delivery") {
      setDate((p) => {
        const n = { ...p, delivery: { date: e.date, slot: e.slot } };
        dispatch({ type: "setDates", payload: n });
        return n;
      });
    } else if (showDatePicker === "eDelivery") {
      setDate((p) => {
        const n = { ...p, eDelivery: { date: e.date, slot: e.slot } };
        dispatch({ type: "setDates", payload: n });
        return n;
      });
    }
    setShowDatePicker(null);
  };
  const checkCoupon = () => {
    if (coupon) {
      dispatch({ type: "setCoupon", payload: null });
      setCode("");
    } else if (code.trim() !== "" && !cLoading) {
      setCLoading(true);
      fetchCoupon({
        code,
        amount,
        zone_id: store?.zone_id,
        user_id: customerId,
      }).then(
        (res) => {
          setCLoading(false);
          // console.log(res);
          dispatch({ type: "setCoupon", payload: res });
        },
        (err) => {
          setCLoading(false);
          err?.errors?.forEach((er) => {
            toast.error(er.message);
          });
        }
      );
    }
  };

  React.useEffect(() => {
    if (services.length !== 0 && cart.length !== 0) {
      setLoading(true);
      const temp = cart.reduce((result, item) => {
        const key = item.serviceId;
        setOpen((prev) => ({
          ...prev,
          [key]: true,
        }));
        if (!result[key]) {
          result[key] = {
            services_id: key,
            service: services.find((s) => s.id === key)?.name,
            open: true,
            items: [],
          };
        }
        const {
          laundry_item_id,
          price,
          quantity,
          bar_code,
          name,
          addons,
          is_bundle_active,
          bundle_free,
          free_items,
          bundle_buy,
          item_note,
        } = item;
        result[key].items.push({
          laundry_item_id,
          price,
          quantity,
          bar_code,
          name,
          addons,
          free_items,
          bundle_free,
          bundle_buy,
          is_bundle_active,
          item_note,
        });
        return result;
      }, {});
      const tempTemp = Object.values(temp);
      const anotherTemp = [];
      for (let i = 0; i < tempTemp.length; i++) {
        const x = tempTemp[i];
        anotherTemp.push(x);
      }
      setItems(anotherTemp);
      setLoading(false);
    }
  }, [cart, services]);

  const HandleAddressChange = (e) => {
    if (addressModal === "pickup") {
    } else {
      setAddress((v) => {
        const payload = {
          ...v,
          destination_coordinates: {
            longitude: e.longitude,
            latitude: e.latitude,
          },

          destination_address: {
            floor: null,
            road: null,
            house: null,
            address: e.address,
            contact_person_name: null,
            contact_person_number: null,
            addressLine1: e.address1,
            addressLine2: e.address2,
            area: e.area?.[0]?.name,
            area_phase: e.phase?.[0]?.name,
          },
          isStore: false,
        };
        dispatch({ type: "setAddresses", payload });
        return payload;
      });
    }
    setAddressModal(null);
  };

  React.useEffect(() => {
  console.log("Pickup:", {
    date: date.pickup.date,
    slot: date.pickup.slot,
  });

  console.log("Delivery:", {
    date: date.delivery.date,
    slot: date.delivery.slot,
  });
}, [date]);

  return (
    <>
      <TitleHeader
        title={"Order Summary"}
        subtitle={
          "Review your order details and get ready for a fresh, clean wardrobe!"
        }
      />
      <div className="container">
        <div className="row justify-content-center py-4">
          <div
            className="col-xl-6 col-lg-7 col-md-10 col-12"
            style={{ minHeight: "80vh" }}
          >
            {/* Pricing Details */}
            {loading ? (
              <div className="w-100 text-center py-3">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <>
                <OrderSummaryItems
                  items={items}
                  open={open}
                  setOpen={setOpen}
                />
                <div className="card  mb-3">
                  {deliveryTypes ? (
                    <TotalPriceCard deliveryType={deliveryTypes[orderTypeId]} />
                  ) : null}
                </div>
                {/* Coupon */}
                <div className="card mb-3">
                  <div className="card-body">
                    <span className="fw-semibold mb-3 d-block">
                      Apply Coupon
                    </span>
                    <div className="input-group" style={{ height: "44px" }}>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Coupon Code"
                        value={code}
                        onChange={(e) => setCode(e.target.value)}
                      />
                      <button
                        className={`btn text-white fw-semibold ${
                          coupon ? "btn-danger" : "btn-primary"
                        }`}
                        type="button"
                        onClick={() => checkCoupon()}
                        disabled={cLoading}
                      >
                        {cLoading ? (
                          <Spinner variant="white" size="sm" />
                        ) : coupon ? (
                          "Remove"
                        ) : (
                          "Apply"
                        )}
                      </button>
                    </div>
                  </div>
                </div>
                {/* Address */}
                <div className="card mb-3">
                  <div className="card-body">
                    <span className="fw-semibold mb-3 d-block">Address</span>
                    <div
                      className={`row`}
                      // onClick={() => {
                      //   if (selfPick === "true" || selfPick === true)
                      //     setAddressModal("pickup");
                      // }}
                    >
                      <div className="col-1 text-end pe-0">
                        <i
                          className="fa-solid fa-circle-dot"
                          style={{ color: "#32b6e9" }}
                        ></i>
                      </div>
                      <div className="col-11">
                        <h6 className="mb-1">Pickup Address</h6>
                        <p className="m-0">
                          {address?.pickup_address
                            ? `${address?.pickup_address?.addressLine1}, ${address?.pickup_address?.addressLine2}, ${address?.pickup_address?.area}, ${address?.pickup_address?.area_phase}`
                            : "Select address"}
                        </p>
                        <hr style={{ borderStyle: "doted" }} />
                      </div>
                    </div>

                    <div
                      className={`row${
                        selfPick === "true" || selfPick === true
                          ? " cursor-pointer"
                          : ""
                      }`}
                      onClick={() => {
                        if (selfPick === "true" || selfPick === true)
                          setAddressModal("delivery");
                      }}
                    >
                      <div className="col-1 text-end pe-0">
                        <i
                          className="fa-solid fa-location-dot text-primary"
                          style={{ fontSize: "20px" }}
                        ></i>
                      </div>
                      <div className="col-11">
                        <h6 className="mb-1">Delivery Address</h6>
                        <p className="m-0">
                          {address?.destination_address
                            ? `${address?.destination_address?.addressLine1}, ${address?.destination_address?.addressLine2}, ${address?.destination_address?.area}, ${address?.destination_address?.area_phase}`
                            : "Select address"}
                        </p>
                      </div>
                    </div>
                    <div>
                      <div className="col-12 d-flex align-items-center justify-content-center flex-column">
                        <hr
                          style={{ borderStyle: "doted" }}
                          className="w-100"
                        />
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={selfPick === "false" || selfPick === false}
                            onChange={(e) =>
                              dispatch({
                                type: "setSelfPick",
                                payload: !e.target.checked,
                              })
                            }
                            id="self-pick-checkbox"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="self-pick-checkbox"
                          >
                            Customer will collect delivery from store
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Date pickers */}
                <div className="card mb-3">
                  <div className="card-body">
                    <span className="fw-semibold mb-3 d-block">
                      Schedule Dates
                    </span>
                    {datesLoading ? (
                      <div className="w-100 text-center py-3">
                        <div
                          className="spinner-border text-primary"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      <div className="app-dates-container border border-gray rounded mt-4 py-2 py-md-0">
                        <div className="col-12 col-md-5 px-4">
                          <small
                            style={{ position: "absolute", top: "-12px" }}
                            className="bg-white px-2"
                          >
                            Pickup
                          </small>
                          <div
                            className="d-flex align-items-center py-3 border-r border-gray cursor-pointer"
                            onClick={() => setShowDatePicker("pickup")}
                          >
                            <i
                              className="fa-regular fa-calendar-plus me-3"
                              style={{ fontSize: "22px", color: "#666" }}
                            ></i>
                            {date?.pickup?.date
                              ? format(date.pickup.date, "eee, do MMM")
                              : "Date"}
                            {date?.pickup?.slot && date?.pickup?.date ? (
                              <br />
                            ) : (
                              "/"
                            )}
                            {date?.pickup?.slot
                              ? `${date.pickup.slot?.start_time} - ${date.pickup.slot?.end_time}`
                              : "Time"}
                          </div>
                        </div>
                        <div className="col-1 d-none d-md-block border-start border-gray h-100 py-2 border-2">
                          &nbsp;
                        </div>
                        <hr className="w-100 my-2 d-block d-md-none" />
                        <div className="col-12 col-md-5 px-4">
                          <small
                            style={{ position: "absolute" }}
                            className={`bg-white px-2 app-dates-delivery-label ${
                              !date?.pickup?.date && !date?.pickup?.slot
                                ? "alt"
                                : ""
                            }`}
                          >
                            Delivery
                          </small>
                          <div
                            className="d-flex align-items-center py-3 cursor-pointer"
                            onClick={() => {
                              if (date?.pickup?.date && date?.pickup?.slot)
                                setShowDatePicker("delivery");
                              else
                                toast.error(
                                  "Please select pickup date & slot first..."
                                );
                            }}
                          >
                            <i
                              className="fa-regular fa-calendar-plus me-3"
                              style={{ fontSize: "22px", color: "#666" }}
                            ></i>
                            {date?.delivery?.date
                              ? format(date.delivery.date, "eee, do MMM")
                              : "Date"}
                            {date?.delivery?.slot && date.delivery.date ? (
                              <br />
                            ) : (
                              "/"
                            )}
                            {date?.delivery?.slot
                              ? `${date.delivery.slot?.start_time} - ${date.delivery.slot?.end_time}`
                              : "Time"}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {/* Note */}
                {/* <div className="card mb-3">
                  <div className="card-body">
                    <span className="fw-semibold mb-3 d-block">
                      Order Note / Instructions
                    </span>
                    <textarea
                      className="form-control"
                      rows="3"
                      value={note || ""}
                      onChange={(e) => setNote(e.target.value)}
                    ></textarea>
                  </div>
                </div> */}
                  <div className="card mb-3">
                    <div className="card-body">
                      <OrderNotesPicker
                        apiNotes={apiNotes}          
                        value={note}                 
                        onChange={setNote}           
                      />
                    </div>
                  </div>
              </>
            )}
          </div>
        </div>
      </div>
      {!loading ? (
        <>
          <div className="container-fluid bg-white">
            <div
              className="row justify-content-center"
              style={{ padding: "20px 0px" }}
            >
              <div
                className="d-flex col-lg-6 col-md-7 col-12 justify-content-center"
                style={{ columnGap: "20px" }}
              >
                <div
                  className="service-btn cart"
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  Back
                </div>
                {/* { dates?.delivery && dates?.pickup ? (
              <Link className="service-btn next" to="/order-review">
                Next
              </Link>
            ) : ( */}
                <button
                  className="service-btn next"
                  onClick={() => {
                    if (!dates?.delivery || !dates?.pickup) {
                      toast.error(
                        "Please select pickup & delivery dates to continue."
                      );
                      return;
                    }
                    console.log(selfPick);
                    console.log(address);

                    if (
                      !address.pickup_address ||
                      !address.destination_address
                    ) {
                      toast.error(
                        "Please select delivery addresses to continue."
                      );
                      return;
                    }
                    if (dates?.delivery && dates?.pickup)
                      if (address.pickup_address && address.destination_address)
                        navigate("../review");
                  }}
                >
                  Next
                </button>
                {/* )} */}
              </div>
            </div>
          </div>
          {/* Pickup date modal*/}
          <Modal
            show={showDatePicker}
            backdrop="static"
            keyboard={false}
            centered
            onHide={() => setShowDatePicker(null)}
          >
            <Modal.Header closeButton className="py-2">
              <Modal.Title style={{ fontSize: "18px" }}>
                Choose Preferred{" "}
                {showDatePicker === "pickup"
                  ? "Pickup"
                  : showDatePicker === "delivery"
                  ? "Delivery"
                  : ""}{" "}
                Date / Time
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {showDatePicker ? (
                <DatePicker
                  range={
                    showDatePicker === "pickup"
                      ? pickupRange
                      : showDatePicker === "delivery"
                      ? deliveryRange
                      : []
                  }
                  selected={date[showDatePicker]?.date}
                  onChange={HandleDateChange}
                  orderType={bookingType}
                  timeSlot={date[showDatePicker]?.slot}
                  pickup={
                    showDatePicker === "delivery"
                      ? {
                          date: date.pickup?.date
                            ? format(date.pickup?.date, "yyyy-MM-dd")
                            : null,
                          slotId: date.pickup?.slot?.id,
                        }
                      : {}
                  }
                  type={showDatePicker === "pickup" ? 1 : 2}
                />
              ) : null}
            </Modal.Body>
          </Modal>
        </>
      ) : null}
      {Boolean(addressModal) ? (
        <AddressPicker
          show={Boolean(addressModal)}
          closeButton={true}
          onHide={() => setAddressModal(null)}
          title={` Select Your ${
            addressModal === "pickup" ? "Pickup " : "Delivery"
          } Address`}
          onSelect={HandleAddressChange}
          showDelete={false}
          showEdit={false}
        />
      ) : null}
    </>
  );
};
